import React, { useState, useEffect } from 'react';
import TextBox from 'components/formInputs/textBox/TextBox';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ValidateLoginEmail from 'components/commonLayouts/Validations/emailValidation/ValidateLoginEmail';
import PreviousButton from './openKnotsLoginHelpers/PreviousButton';
import FormHeader from './openKnotsLoginHelpers/FormHeader';
import FormHeaderLabel from './openKnotsLoginHelpers/FormHeaderLabel';
import FormButton from './openKnotsLoginHelpers/FormButton';
const OpenKnotsForgotPasswordComponent = (props) => {
    const baseUrlAuth = process.env.REACT_APP_AUTH_MANAGEMENT;
    const [email, setEmail] = useState();
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState();

    const [isLinkSent, setIsLinkSent] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showLoading, setShowLoading] = useState(false)
    const navigate = useNavigate();

    const [timer, setTimer] = useState(0);

    useEffect(() => {
        if (timer <= 0) return;

        const timeoutId = setTimeout(() => {
            setTimer((current) => current - 1);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [timer]);

    const handleEmail = (e) => {
        setEmailError(false);
        setEmailErrorMessage();
        setEmail(e.target.value);
    };

    const handleForgotPassword = () => {
        const { emailErr, emailErrMessage } = ValidateLoginEmail(email);
        if (emailErr) {
            setEmailError(emailErr);
            setEmailErrorMessage(emailErrMessage);
        } else {
            setShowLoading(true)
            //Send Reset link to email
            axios
                .post(
                    `${baseUrlAuth}/sendResetLink`,
                    { userName: email, source: 'openknots' },
                    {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                    }
                )
                .then((res) => {
                    if (res.status === 200) {
                        //send otp to email
                        axios
                            .post(
                                `${baseUrlAuth}/sendConfirmationCode`,
                                { userName: email },
                                {
                                    headers: {
                                        'content-type': 'application/x-www-form-urlencoded',
                                    },
                                }
                            )
                            .then((res) => {
                                if (res.status === 200) {
                                    setTimer(60);
                                    setShowModal(true);
                                } else {
                                    setIsLinkSent(false);
                                }
                            })
                            .catch((error) => {
                                setIsLinkSent(false);
                            });
                    }
                })
                .catch((error) => {
                    setIsLinkSent(false);
                })
                .finally(() => {
                    setShowLoading(false)
                });
        }
    };

    const handleSuccessModal = () => {
        let path = '/openknots/login';
        navigate(path);
    };

    const getMsgIconClass = (type) => {
        if (type === 'error') {
            return 'sf-error error-icon';
        }
        if (type === 'success') {
            return 'sf-check success-icon';
        }
        return 'sf-info info-icon';
    };

    return (
        <div className='opk-login-panel'>
            <div className='opk-login-card d-flex align-items-center flex-column'>
                <Link to='/openknots/login'>
                    <PreviousButton previousPage='login' />
                </Link>
                <FormHeader />
                <div className='col-12 col-md-5 position-relative bg-white' id='loginInput'>
                    <div className='d-md-flex justify-content-center align-items-center vh-100'>
                        <div className='col-12 col-md-10 text-start w-100 d-flex flex-column align-items-center justify-content-center'>
                            {showModal && (


                                <div className='msg-modal border-success mb-4 min-w-100 opk-success-modal' >
                                    <p className='float-end mb-0'>
                                        <span className='sf-close pe-2 cursor text-neutral-900' onClick={handleSuccessModal}></span>
                                    </p>
                                    <div className='media'>
                                        <span
                                            className={`msg-icon float-start ms-2 ${getMsgIconClass("success")}`}></span>
                                        <div className='media-body text-neutral-900 ms-3'>
                                            <p className='mt-0 font-b2 text-start font-medium mb-0 px-4 text-neutral-900'>
                                                SUCCESS
                                            </p>
                                            <p className='text-start font-b3 px-4 text-neutral-900'>You will receive an OTP if this email address exists in our system</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <FormHeaderLabel UpperText="Forgot Password" fs="28px" />
                            <p className='text-neutral-900 row w-70 opk-forgot-form-subheading'>
                                <span className='col-2 d-flex align-items-center justify-content-center ps-4'><img src='/images/Vector.png' alt='Reset Vector' /></span>
                                <span className='col-10'>Enter your email ID, a reset password link will be sent to it to help change your password.</span>
                            </p>
                            <div className='col-lg-10 mt-3 w-100'>
                                <TextBox
                                    label='Email'
                                    type='text'
                                    id='userEmail'
                                    placeholder='Enter your email'
                                    onChange={handleEmail}
                                    error={emailError}
                                    errorMessage={emailErrorMessage}
                                    name='email'
                                    value={email}
                                />
                            </div>
                            {!isLinkSent && !showModal && (
                                <div className='col-lg-10 mt-3 w-100' role='alert'>
                                    <div
                                        className='err-message-background  px-3 py-2 rounded mt-3 font-b2 h-100'
                                        role='alert'>
                                        <i className='sf-warning-filled text-error-700 me-2'></i>
                                        <span className='font-b2'>Something went wrong!</span>
                                    </div>
                                </div>
                            )}
                            <div className='col-lg-10 mt-3 pt-1 w-100'>
                                <FormButton handleLogin={handleForgotPassword} showLoading={showLoading} Text='Send Link' />
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default OpenKnotsForgotPasswordComponent;
